import { gql } from "@apollo/client";

export const listProducts = gql`
  query ListProducts($filters: KeywordGroupFilter, $showDeleted: Boolean!) {
    listKeywordGroups(
      type: "PRODUCT"
      filters: $filters
      showDeleted: $showDeleted
    ) {
      id
      name
      type
      slug
      imageUrl
      keywords
      keywordsGroupIds
      deleted
      metadata
      category
      isLinked
      linkedTo {
        attachedTo
        id
        name
      }
    }
  }
`;
